import { Component, OnInit, Inject } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { IDocument } from 'src/app/models/IDocument';
import { ConfirmDialogModel, DeleteDocumentComponent } from 'src/app/PatientChart/Document/delete-document/delete-document.component';
import { DocumentService } from 'src/app/Services/Documents/document.service';

export interface DialogData {
  animal: string;
  name: string;
}




@Component({
  selector: 'app-add-category',
  templateUrl: './add-category.component.html',
  styleUrls: ['./add-category.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class AddCategoryComponent implements OnInit {

  AddCategoryForm: FormGroup;
  displayedColumns = ['documentCategory', 'action'];
  headercolumnsToDisplay = ['Category Name', 'Action'];
  expandedElement: IDocument | null;
  public dataSource: IDocument[];
  public show: boolean = false;
  public delEmployer: string = "";

  showInfo() {
    this.show = !this.show;
    this.message = '';
    this.AddCategoryForm.patchValue({
      categoryName: ''
    })
    this.expandedElement = null;
  }
  constructor(
    public dialogRef: MatDialogRef<AddCategoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private fb: FormBuilder, private docService: DocumentService
    , private toastr: ToastrService, public dialog: MatDialog) { }

  ngOnInit() {
    this.AddCategoryForm = this.fb.group({
      categoryName: [''],
    });

    this.getSavedCategoryNames();
  }
  public result: any;
  docmentInfo: IDocument;
  public docCatLists: IDocument[] = [];
  public message: string = '';
  public existList: IDocument[];
  SaveCategoryName(id: any) {
    this.docmentInfo = {} as IDocument;
    this.docmentInfo.documentCategory = this.AddCategoryForm.value.categoryName;
    this.docmentInfo.docCategoryId = id != 0 ? id : 0;
    if (this.docmentInfo.documentCategory != "") {

      this.existList = this.docCatLists.filter(x => x.documentCategory.toLocaleLowerCase() === this.docmentInfo.documentCategory.toLocaleLowerCase());
      if (this.existList.length > 0) {
        this.message = "This Category Name Already Exist.";
        return;
      }

      this.docService.SaveDocCategory(this.docmentInfo, Number(sessionStorage.getItem("FacilityId"))).subscribe((results: any) => {
        this.result = results;
        this.toastr.success('Document Category Saved Successfully');
        this.show = false;
        this.message = '';
        this.AddCategoryForm.patchValue({
          categoryName: ''
        })
        this.getSavedCategoryNames();
      });

    } else {
      this.message = 'Please Enter Category Name.'
    }

  }
  getSavedCategoryNames() {
    this.docService.getAllLocDocCategory(Number(sessionStorage.getItem('patientId')), Number(sessionStorage.getItem("FacilityId"))).subscribe(data => {
      this.docCatLists = data;
      this.dataSource = data;
    });
  }
  catCount: number = 0;
  getAllCategoriesCountById() {
    this.docService.getAllCategoriesCount(0).subscribe(data => {
      this.catCount = data;
      //  alert(this.catCount)
    });
  }
  onCellClick(elemnt: IDocument) {
    this.show = false;
    this.catName = elemnt.documentCategory;
    this.catId = elemnt.docCategoryId;
    if (this.delEmployer === "delete") {
      this.expandedElement = null
    } else {
      this.AddCategoryForm.patchValue({
        categoryName: this.catName
      });
    }
  }
  public catName: string;
  public catId: number = 0;
  res: any;
  docDeletResult: any;
  onCategoryclick(elemnt: IDocument) {
    this.catName = elemnt.documentCategory;
    this.catId = elemnt.docCategoryId;
    this.show = true;
    this.AddCategoryForm.patchValue({
      categoryName: this.catName
    })
  }
  deleteSelectedCategory(elemnt: IDocument, delNo: string) {
    this.delEmployer = delNo;
    // this.docService.getAllCategoriesCount(elemnt.docCategoryId).subscribe(data => {
    //   this.catCount = data;
    //   // alert(this.catCount)
    // });

    // if (this.catCount > 0) {
    //   const message = "This category already associated with some other locations,still do you want to delete? ";
    //   const dialogData = new ConfirmDialogModel('Confirm Action', message);
    //   const dialogRef = this.dialog.open(DeleteDocumentComponent, {
    //     maxWidth: '400px',
    //     height: '130px',
    //     data: dialogData
    //   });

    //   dialogRef.afterClosed().subscribe(dialogResult => {
    //     this.result = dialogResult;
    //     if (this.result) {
    //       this.docService.DeleteAddCategory(elemnt.docCategoryId).subscribe(
    //         data1 => {
    //           this.res = data1;

    //           //   this.toastr.success(this.res)
    //           //   this.getSavedCategoryNames();     
    //           //this.toastr.success('Document category deleted successfully.');
    //         }, (err: any) => console.log(err));
    //     } else {
    //       this.result = dialogResult;
    //     }

    //   });
    // } else {

    this.docService.DeleteAddCategory(elemnt.docCategoryId).subscribe(
      data1 => {
        this.res = data1;

        if (this.res === "4") {
          const message = "Are you sure to delete this Category Name ? ";
          const dialogData = new ConfirmDialogModel('Confirm Action', message);
          const dialogRef = this.dialog.open(DeleteDocumentComponent, {
            maxWidth: '400px',
            height: '130px',
            data: dialogData
          });

          dialogRef.afterClosed().subscribe(dialogResult => {
            this.result = dialogResult;
            this.expandedElement = null;
            this.delEmployer = "";
            if (this.result) {
              this.docService.DeleteDocumentCategory(elemnt.docCategoryId).subscribe(
                data2 => {
                  this.docDeletResult = data2;
                  this.toastr.success(this.docDeletResult)
                  this.getSavedCategoryNames();

                });
              this.delEmployer = "";
            } else {
              this.result = dialogResult;
            }

          });


        } else if (this.res === "1") {
          this.delEmployer = "";
          const message1 = "The 'Category Name' that you are trying to delete has files associated with it in the Documents section.  Hence, this cannot be deleted. ";
          this.toastr.error(message1)
        } else if (this.res === "2") {
          this.delEmployer = "";
          const message2 = "The 'Category Name' that you are trying to delete has been associated with either Office Category or ASC Category for some of the locations.  You have to disassociate them before trying to delete this Category. ";
          this.toastr.error(message2)
        } else if (this.res === "3") {
          this.delEmployer = "";
          const message3 = "The 'Category Name' that you are trying to delete has files associated with it in the Documents section & it has been associated with either Office Category or ASC Category for some of the locations.  Hence, this cannot be deleted. ";
          this.toastr.error(message3)
        }
        // this.docService.getAllCategoriesCount(elemnt.docCategoryId).subscribe(data => {
        //   this.catCount = data;
        //   alert('count : ' + this.catCount)

        // });

        // if (this.res == "Failed to Delete Document Name.") {
        //   // const message = "The 'Category Name' that you are trying to delete has files associated with it in the Documents section.  Hence, this cannot be deleted.";
        //   // const dialogData = new ConfirmDialogModel('Confirm Action', message);
        //   // const dialogRef = this.dialog.open(DeleteDocumentComponent, {
        //   //   maxWidth: '400px',
        //   //   height: '130px',
        //   //   data: dialogData
        //   // });
        // } else if ("Failed to Delete Time Zone"){
        //    const message = "The 'Category Name' that you are trying to delete has been associated with either Office Category or ASC Category for some of the locations.  You have to disassociate them before trying to delete this Category.";

        // }
        // else if ("Document Name delete successfully.") {
        //   this.toastr.success(this.res)
        //   this.getSavedCategoryNames();

        // }
        // this.toastr.success('Document category deleted successfully.');
      }, (err: any) => console.log(err));


    //}
  }
  onNoClick(): void {
    //this.dialogRef.close();
    this.show = false;
    this.message = '';
    this.AddCategoryForm.patchValue({
      categoryName: ''
    })
    this.expandedElement = null;
  }
  onClearClick() {
    this.dialogRef.close();
  }

}
